import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import useRoleContext from 'contexts/role.context';
import React from 'react';
import { STORAGE_KEYS } from 'utils/constants';

const AdminRoleDropdown = () => {
  const { role } = useRoleContext();

  // Include more roles here to impersonate other roles
  const MAIN_ADMIN_ROLES = [
    {
      name: 'CS Admin',
      value: ENUM_ROLE.CS_ADMIN
    },
    {
      name: 'CS Super Admin',
      value: ENUM_ROLE.CS_SUPER_ADMIN
    },
    {
      name: 'Kitchen supervisor',
      value: ENUM_ROLE.KITCHEN_ADMIN
    },
    {
      name: 'Logistics super admin',
      value: ENUM_ROLE.LOGISTICS_SUPER_ADMIN
    },
    {
      name: 'Security',
      value: ENUM_ROLE.SECURITY
    }
  ];

  const getCurrentAdminRole = () => {
    return MAIN_ADMIN_ROLES.find((r) => r.value === role)?.name ?? '';
  };

  const handleChangeRole = (selectedRole: ENUM_ROLE) => {
    if (role === selectedRole) return;
    localStorage.setItem(STORAGE_KEYS.ROLE, selectedRole);
    location.reload();
  };
  return (
    <Dropdown
      content={
        <div className='border border-gray-border flex gap-[.6rem] items-center leading-[40px] pl-4 pr-1 rounded-lg'>
          <span className='text-[12px] font-medium'>{getCurrentAdminRole()} </span>
          <div className='rounded-full text-gray-5 cursor-pointer hover:bg-gray-1 transition-all'>
            <ArrowDownIcon />
          </div>
        </div>
      }>
      <DropdownList className='min-w-[190px]'>
        {MAIN_ADMIN_ROLES.map((r) => (
          <DropdownItem
            key={r.name}
            className='text-sm font-medium'
            onClick={() => handleChangeRole(r.value)}>
            <button className='cursor-pointer items-center flex'>{r.name}</button>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default AdminRoleDropdown;
